import { generatePath, To } from 'react-router-dom'

import { Table, usePagination } from 'components/Table'
import { PaginationProps } from 'components/Table/Pagination'
import { useSort } from 'components/Table/Sort'
import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { calculatePagination } from 'providers/tanstack-query/utils'
import { ROUTES } from 'routes'
import { DEFAULT_SORT, SORTABLE_COLUMNS } from './constants'
import { useGetDomains } from './hooks/useGetDomains'
import { DomainsForTable, DomainSortBy, DomainsTableProps } from './types'
import { useColumns } from './useColumns'

export const DomainsTable = ({ filters }: DomainsTableProps): JSX.Element => {
  const { workspaceId } = useWorkspaceParam()

  const columns = useColumns()
  const { page, rowsPerPage, setPage, ...usePaginationProps } = usePagination({
    resetOnChange: [filters],
  })
  const { props: sortProps, sort } = useSort<DomainsForTable, DomainSortBy>(
    DEFAULT_SORT,
    SORTABLE_COLUMNS,
  )

  const { count, domains, loading } = useGetDomains({
    filters,
    ...calculatePagination({ page, rowsPerPage }),
    sort,
  })

  const handleRowClick = (row: DomainsForTable): To =>
    generatePath(ROUTES.INVENTORY.DOMAIN.EDIT, {
      id: row.id,
      tab: 'general',
      workspaceId,
    })

  const paginationProps: PaginationProps = {
    count,
    page,
    rowsPerPage,
    setPage,
    ...usePaginationProps,
  }

  return (
    <Table<DomainsForTable>
      columns={columns}
      data={domains}
      loading={loading}
      meta={{ stickyHeader: true }}
      onClickRow={handleRowClick}
      pagination={paginationProps}
      sort={sortProps}
    />
  )
}
